import { VStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Icon } from "@/shared/ui/primitives";

export const HeroSection = () => {
	const { t } = useTranslation();

	return (
		<VStack className="w-full h-screen gap-[40px] relative">
			{/* 타이틀 영역 */}
			<VStack className="gap-[16px] max-w-[800px]">
				<motion.h1
					className="text-[2.5rem] md:text-[3rem] text-ct-strong font-semibold text-center"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
				>
					{t("company.hero.title")}
				</motion.h1>
				<motion.p
					className="text-lg md:text-xl text-ct-regular font-medium text-center"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.2 }}
				>
					{t("company.hero.subtitle")}
				</motion.p>
			</VStack>
			<motion.div
				className="absolute bottom-[16px] text-ct-weak"
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: [0, 8, 0] }}
				transition={{
					opacity: { duration: 0.6 },
					y: { duration: 1.5, repeat: Infinity, ease: "easeInOut" },
				}}
			>
				<Icon name="Down" width={40} height={40} />
			</motion.div>
		</VStack>
	);
};
